export function useGtm() {
  const gtm = useScriptGoogleTagManager({
    id: 'GTM-PPGZX5RJ',
  })

  return gtm
}
